import { render, staticRenderFns } from "./SubtaskPopover.vue?vue&type=template&id=1e1344ea&scoped=true&"
import script from "./SubtaskPopover.vue?vue&type=script&lang=js&"
export * from "./SubtaskPopover.vue?vue&type=script&lang=js&"
import style0 from "./SubtaskPopover.vue?vue&type=style&index=0&id=1e1344ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1344ea",
  null
  
)

export default component.exports